import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {Navigate} from "react-router";
import {useGlobalContext} from "../hooks/useGlobalContext";
import {useUser} from "../hooks/useUser";
import {PrivateRoutes, PublicRoutes, WelcomeScreens} from "../routes";

export default function NavigateToDefault(): JSX.Element {
	const globalContext = useGlobalContext();
	const customWelcome = globalContext.installation.configuration.features["welcome"];
	const welcome = isNullOrEmpty(customWelcome) ? null : WelcomeScreens[customWelcome];
	const user = useUser();
	if (user.authStatus == "unauthorized") {
		if (welcome == null) {
			return <Navigate to={PublicRoutes.welcome}/>;
		}

		return <Navigate to={welcome.path}/>;
	}

	return <Navigate to={PrivateRoutes.permitsHome}/>;
}
